__turbopack_context__.v({
  "fadeChildren": "Animation-module__n93DVq__fadeChildren",
  "fadeIn": "Animation-module__n93DVq__fadeIn",
});
